import React from 'react';
import { Outlet } from 'react-router-dom';

import './UrgentCampaigns.styles.scss';

const UrgentCampaigns: React.FC = () => {
  return (
    <div className="urgent-campaigns-router">
      <Outlet />
    </div>
  );
};

export default UrgentCampaigns;
